import Vue from 'vue';
import can from './can';



Vue.mixin({
	methods: {
		can,
	}
});